import {Icon} from '@iconify/react';
import React, {ReactElement, useState} from 'react';
import {DeviceType} from '../../../incase-domain/common/DeviceType.enum';
import Button from '../../../incase-domain/components/button/Button';
import {ELEMENTS} from '../../../incase-domain/elements/base/elementsData';
import {ELEMENT, ELEMENT as ELEMENT_TYPE} from '../../../incase-domain/elements/base/ElementTypes';
import {IElementPlaceholder} from '../../../incase-domain/elements/placeholder';
import {IElementVideo} from '../../../incase-domain/elements/video';
import {getEmptyElement} from '../../../service/element';
import CreateVideoElementModal from '../../../ui/components/common/modal/createdElementModals/CreateVideoElementModal';
import useElementActions from '../../../utils/hooks/slideUpdates/useElementActions';
import HighlightedInputMedia from '../../fileLoader/input.media';
import useImgFileReader from '../../fileLoader/util/useImgFileReader';

interface PlaceholderElement {
    element: IElementPlaceholder;
    device?: DeviceType;
}

function PlaceholderElement(props: PlaceholderElement): ReactElement {
    const {element, device} = props;

    const {updateElement} = useElementActions();

    const [isVideoModalOpen, setIsVideoModalOpen] = useState(false);

    const imageElementData = ELEMENTS.find((item) => item.type === ELEMENT_TYPE.IMAGE);
    const videoElementData = ELEMENTS.find((item) => item.type === ELEMENT_TYPE.VIDEO);

    const onImageLoad = useImgFileReader((images) => {
        const {imageSrc, widthHeightRatio} = images[0];
        const createdElement = getEmptyElement(element.slideId, ELEMENT.IMAGE, {
            imageSrc,
            width: element.width,
            height: element.height,
            widthHeightRatio,
            xPosition: element.xPosition,
            yPosition: element.yPosition,
        });

        updateElement(element.elementIndex, {
            ...createdElement,
            fitContent: false,
            name: `Image: ${element.elementIndex}`,
        });
    });

    const onVideoLoad = (videoSource: IElementVideo['videoSource']): void => {
        const createdElement = getEmptyElement(element.slideId, ELEMENT.VIDEO, {
            videoSource,
            width: element.width,
            height: element.height,
            xPosition: element.xPosition,
            yPosition: element.yPosition,
        });

        updateElement(element.elementIndex, {
            ...createdElement,
            fitContent: false,
            name: `Video: ${element.elementIndex}`,
        });
    };

    return (
        <>
            <div className={`c-placeholderElement ${device === DeviceType.MOBILE && 'c-placeholderElement--mobile'}`}>
                <div className="c-placeholderElement__group">
                    {imageElementData?.icon && (
                        <HighlightedInputMedia
                            type="image"
                            onLoad={onImageLoad}
                            child={
                                <Button variant="soft" color="secondary">
                                    <Icon icon={imageElementData?.icon} fontSize="5em" />
                                </Button>
                            }
                        />
                    )}

                    {videoElementData?.icon && (
                        <Button
                            onClick={() => {
                                setIsVideoModalOpen(true);
                            }}
                            variant="soft"
                            color="secondary"
                        >
                            <Icon icon={videoElementData?.icon} fontSize="5em" />
                        </Button>
                    )}
                </div>
            </div>

            <CreateVideoElementModal
                isOpen={isVideoModalOpen}
                onConfirm={(videoSource) => {
                    onVideoLoad(videoSource);
                    setIsVideoModalOpen(false);
                }}
                onClose={() => {
                    setIsVideoModalOpen(false);
                }}
            />
        </>
    );
}

export default PlaceholderElement;
